// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Promise from 'bluebird';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'prom... Remove this comment to see the full error message
import Queue from 'promise-queue';
import _ from 'underscore';

import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { isTouch } from '@trello/browser';
import { ApiError, makeErrorEnum } from '@trello/error-handling';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import { isPinnedListRoute } from '@trello/router';
import { getSmartCardClient } from '@trello/smart-card/smart-card-client';
import { guardedTrim } from '@trello/strings';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { trackSeparator } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CardComposerInlineTemplate } from 'app/scripts/views/templates/CardComposerInlineTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

/* eslint-disable-next-line @trello/no-module-logic */
const CardComposerError = makeErrorEnum('CardComposer', ['TooManyCards']);

const MAX_PARALLEL_CARD_CREATION = 5;
const MAX_CARD_TITLE_LENGTH = 16384;

// @ts-expect-error TS(2430): Interface 'CardComposerInlineView' incorrectly ext... Remove this comment to see the full error message
interface CardComposerInlineView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _cardCreationApiQueue: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountLabels: any;
}

class CardComposerInlineView extends View {
  className() {
    return 'card-composer';
  }

  events() {
    return {
      'click .js-add-card': 'submitCard',
      'click .js-cancel': 'clearAndHide',

      keyup: 'keyupEvent',
      paste: 'pasteEvent',
      keydown: 'keydownEvent',
    };
  }

  initialize() {
    this.makeDebouncedMethods('render');
    this.listenTo(this.model, 'change:vis', this.autosaveCard);
    this._cardCreationApiQueue = new Queue(MAX_PARALLEL_CARD_CREATION);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    $(document).on('click', this.handleClickOutside);
  }

  remove() {
    $(document).off('click', this.handleClickOutside);
    this.unmountLabels?.();
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClickOutside(event: any) {
    // We aren't interested in this event if the card composer is not open
    if (!this.model.get('vis')) {
      return;
    }

    const $target = $(event.target);

    // We deem the click 'outside' the the card composer if the click wasn't within it's
    // panel, or within the popover that can be used to add Members/Labels etc to the Card
    const wasClickOutside =
      $target.closest('.card-composer').length === 0 &&
      $target.closest('.pop-over').length === 0 &&
      $target.closest('.pop-over-content').length === 0;
    if (wasClickOutside) {
      return this.model.save('vis', false);
    }
  }

  // @ts-expect-error TS(2416): Property 'render' in type 'CardComposerInlineView'... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render(args: any, callback: any) {
    Analytics.sendScreenEvent({
      name: 'inlineCardComposerInlineDialog',
      containers: formatContainers({
        idBoard: this.model.getBoard()?.id,
        idList: this.model.attributes?.list.id,
        idOrganization: this.model.getBoard()?.getOrganization()?.id,
      }),
    });

    const data = {
      placeholder: this.getPlaceholder(),
      isMenuButtonHidden: isPinnedListRoute(),
      ...this.model.toJSON({ board: true }),
    };

    // this toggles classes so lets do it before adding stuff to the DOM
    this.renderVisibility();

    this.$el.html(templates.fill(CardComposerInlineTemplate, data));

    this.defer(() => {
      // we could focus().select() here, but it might override what was typed
      // in the time between submitting the card and getting it
      // back from the server.
      Util.setCaretAtEnd(this.el.querySelector('.js-card-title'));

      // will select card with this callback if we just submitted a card
      return typeof callback === 'function' ? callback() : undefined;
    });

    // @ts-expect-error TS(2339): Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
    $('.js-card-title', this.$el).autosize();

    return this;
  }

  autosaveCard() {
    const val = this.getCardTitle();
    // Check placeholder value because of IE bug where it will save the placeholder
    if (
      val !== '' &&
      val !== this.getPlaceholder() &&
      val.length <= MAX_CARD_TITLE_LENGTH
    ) {
      return this.submitCard(null, { addedFromAutosave: true });
    } else {
      return this.frameDebounce(this.renderVisibility());
    }
  }

  renderVisibility() {
    this.$el.toggleClass('hide', !this.model.get('vis'));
    return this;
  }

  clearTextField() {
    this.model.save('title', '');
    return $('.js-card-title', this.$el).val('').trigger('autosize.resize');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitCard(e: any, opts = { addedFromAutosave: false }) {
    if (e) {
      stopPropagationAndPreventDefault(e);
    }

    // Hide 'add label', 'select members', etc. popovers
    PopOver.hide();

    const s = this.getCardTitle();

    if (s === '') {
      this.$el.find('.js-card-title').focus().select();
      return;
    }

    if (s.length > MAX_CARD_TITLE_LENGTH) {
      this.$el.find('.js-card-title').focus().select();
      Alerts.flash('card title too long', 'error', 'card-composer');
      return;
    }

    const $manyCardsPopOverTarget = e ? $(e.target) : this.$el;
    const options = {
      $elem: $manyCardsPopOverTarget,
      destinationBoard: this.model.getBoard(),
      destinationList: this.model.getList(),
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    const cardTitles = _.compact(s.split(/\r\n|\r|\n/));
    const count = cardTitles.length;
    const countString = count.toString();

    Promise.try(() => {
      if (count > 100) {
        throw new CardComposerError.TooManyCards();
      }

      if (count > 1 && !opts.addedFromAutosave) {
        return new Promise((resolve) =>
          Confirm.toggle('create many cards', {
            elem: $manyCardsPopOverTarget,
            html: l('confirm.create many cards.text', { count: countString }),
            confirmText: l('confirm.create many cards.confirm', {
              count: countString,
            }),
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
            fxConfirm: (e: any) => resolve(true),
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
            fxCancel: (e: any) => resolve(false),
          }),
        );
      } else {
        return false;
      }
    })
      .then((createOnePerLine) => {
        this.clearTextField();
        const openCard = e?.shiftKey === true;

        if (createOnePerLine) {
          this.createMultipleCards(cardTitles, openCard);
        } else {
          // Don't select the card in autocreate card experiment so that a user
          // can use keyboard on board after creating card
          this.createCard(s, {
            openCard,
            selectCard: !opts.addedFromAutosave,
            removeNewLines: true,
          }).catch(ApiError, () =>
            Alerts.flash('could not connect', 'error', 'card-composer'),
          );
        }

        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        return this.clearItems();
      })
      .then(() => {
        if (opts.addedFromAutosave) {
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          this.hide();
          return this.renderVisibility();
        }
      })
      .catch(CardComposerError.TooManyCards, () =>
        // too many cards
        Confirm.toggle('too many cards', {
          elem: $manyCardsPopOverTarget,
          html: l('confirm.too many cards.text', { count: countString }),
          /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
          fxConfirm: (e: any) => PopOver.hide(),
        }),
      )
      .done();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queueCreateCard(title: any, params = {}) {
    // @ts-expect-error TS(2339): Property 'requestData' does not exist on type '{}'... Remove this comment to see the full error message
    params.requestData = this._createCardRequestData(
      title,
      // @ts-expect-error TS(2339): Property 'removeNewLines' does not exist on type '... Remove this comment to see the full error message
      params.removeNewLines,
    );
    return this._cardCreationApiQueue.add(() => this.createCard(title, params));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _createCardRequestData(title: any, removeNewLines: any) {
    title = guardedTrim(title);

    this.$el.trigger('prevent-scroll-selection');

    if (removeNewLines) {
      title = title.replace(/(\r\n|\n|\r)/gm, ' ');
    }

    // clone members and labels you added
    const membersToAdd = _.clone(this.model.get('idMembers'));
    const idLabelsToAdd = _.pluck(this.model.labelList.models, 'id');

    const newCardData = {
      name: title,
      closed: false,
      idLabels: idLabelsToAdd,
      idMembers: membersToAdd,
      dateLastActivity: Date.now(),
    };

    const addsLabels = idLabelsToAdd.length > 0;

    return { newCardData, addsLabels, membersToAdd };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createCard(title: any, param = {}) {
    const smartCardClient = getSmartCardClient();

    // @ts-expect-error TS(2339): Property 'openCard' does not exist on type '{}'.
    const { openCard, selectCard, removeNewLines, requestData } = param;
    return new Promise((resolve, reject) => {
      const { newCardData, addsLabels, membersToAdd } =
        requestData ?? this._createCardRequestData(title, removeNewLines);

      if (title === '') {
        return resolve();
      } else {
        const traceId = Analytics.startTask({
          taskName: 'create-card/list',
          source: 'inlineCardComposerInlineDialog',
        });
        // pos needs to be calculated immediately before insertion
        newCardData.pos = this.model.getList().calcPos(this.model.get('index'));
        this.model.moveToNext();

        const card = this.model
          .getList()
          .cardList.createWithTracing(newCardData, {
            traceId: traceId,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error: (model: any, error: any) => {
              this.model.getList().cardList.remove(card);
              Analytics.taskFailed({
                taskName: 'create-card/list',
                traceId,
                source: 'inlineCardComposerInlineDialog',
                error,
              });
              return reject(error);
            },

            /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
            success: async (card: any) => {
              let linkCardProvider = undefined;
              const cardRole = card?.getCardRole();

              if (cardRole === 'link') {
                const url = card.get('name');
                const resolvedUrl = await smartCardClient
                  .fetchData(url)
                  .catch(() => {});

                if (resolvedUrl?.meta) {
                  linkCardProvider =
                    resolvedUrl.meta.key || resolvedUrl.meta.definitionId;
                }
              }

              Analytics.sendTrackEvent({
                action: 'created',
                actionSubject: 'card',
                source: 'inlineCardComposerInlineDialog',
                attributes: {
                  numMembersAdded: membersToAdd?.length,
                  labelsAdded: addsLabels,
                  taskId: traceId,
                  cardRole,
                  linkCardProvider,
                },
                containers: formatContainers({
                  idCard: card?.id,
                  idList: card?.getList()?.id,
                  idBoard: card?.getBoard()?.id,
                  idOrganization: card?.getBoard()?.getOrganization()?.id,
                }),
              });

              trackSeparator({
                cardName: title,
                idCard: card?.id,
                attributes: {
                  category: 'card composer',
                  method: 'by creating a card',
                },
              });

              Analytics.taskSucceeded({
                taskName: 'create-card/list',
                traceId,
                source: 'inlineCardComposerInlineDialog',
              });

              const board = this.model.getBoard();
              board.filter.addNewCard(card);

              if (selectCard) {
                board.viewState.selectCard(card);
              }

              if (openCard) {
                Analytics.sendPressedShortcutEvent({
                  shortcutName: 'createAndOpenCardShortcut',
                  keyValue: Key.Enter,
                  source: 'inlineCardComposerInlineDialog',
                  containers: formatContainers({
                    idCard: card?.id,
                    idList: card?.getList()?.id,
                    idBoard: card?.getBoard()?.id,
                    idOrganization: card?.getBoard()?.getOrganization()?.id,
                  }),
                });
                Controller.showCardDetail(card, {
                  runMethod: card?.shouldSuggestDescription()
                    ? 'expandDesc'
                    : undefined,
                  method: 'via the Shift shortcut from card composer',
                });
              }

              resolve();
            },
            modelCache: this.modelCache,
          });
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createMultipleCards(cardTitles: any, openCard: any) {
    const numCardsLength = cardTitles.length;

    for (let i = 0; i < cardTitles.length; i++) {
      const title = cardTitles[i];
      if (cardTitles.length - 1 === i) {
        this.queueCreateCard(title, { openCard, selectCard: true });
      } else {
        this.queueCreateCard(title);
      }
    }

    Analytics.sendTrackEvent({
      action: 'created',
      actionSubject: 'multipleCards',
      source: 'createMultipleCardsInlineDialog',
      attributes: {
        numCardsLength,
      },
      containers: formatContainers({
        idBoard: this.model.getBoard()?.id,
        idList: this.model.attributes?.list.id,
        idOrganization: this.model.getBoard()?.getOrganization()?.id,
      }),
    });
  }

  pasteEvent() {
    $('.js-card-title', this.$el).focus().keyup().trigger('autosize.resize');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    const key = getKey(e);

    const $titleInput = $('.js-card-title', this.$el);
    const isTitle = $(e.target)
      .closest('.js-card-title')
      .hasClass('js-card-title');
    const isJsAddCard = $(e.target)
      .closest('.js-add-card')
      .hasClass('js-add-card');

    if ((isTitle || isJsAddCard) && !PopOver.isVisible && key === Key.Enter) {
      stopPropagationAndPreventDefault(e);
      this.submitCard(e, { addedFromAutosave: false });
      return;
    }

    if (key === Key.Escape) {
      return this.saveDraftAndHide();
    } else if ([Key.Tab, Key.Enter].includes(key)) {
      $titleInput.focus();

      const word = Util.getWordFromCaret($titleInput[0]);

      if (key === Key.Tab && $titleInput.val() === '') {
        stopPropagationAndPreventDefault(e);
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.hide();
        if (e.shiftKey) {
          $(this.el)
            .closest('.js-list')
            .find('.editable:first .current')
            .click();
        } else {
          $(this.el)
            .closest('.js-list')
            .next()
            .find('.editable:first .current')
            .click();
        }

        stopPropagationAndPreventDefault(e);
        Util.insertSelection($titleInput, '', word.start, word.end);
        this.model.set('title', $titleInput.val());
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    const $titleInput = $('.js-card-title', this.$el);

    const key = getKey(e);

    if ([Key.Tab, Key.Enter].includes(key)) {
      return;
    }

    if (key === Key.Escape) {
      stopPropagationAndPreventDefault(e);
      PopOver.hide();
      $titleInput.focus();
      return;
    }

    if (
      !isTouch() &&
      $(e.target).closest('.js-card-title').hasClass('js-card-title')
    ) {
      // add current text
      this.model.set('title', this.getCardTitle());

      return PopOver.hide();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearItems(e: any) {
    return this.model.clearItems();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hide(e: any) {
    this.model.save('vis', false);
  }

  saveDraftAndHide() {
    this.model.save('title', this.getCardTitle());
    $('.js-card-title', this.$el).val('');
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearAndHide(e: any) {
    // Set title to nothing so that autosave doesn't save on close
    $('.js-card-title', this.$el).val('');
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    this.clearItems();
    this.$el.toggleClass('hide', true);
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this.hide();
  }

  scrollIntoView() {
    // @ts-expect-error TS(2339): Property 'top' does not exist on type 'Coordinates... Remove this comment to see the full error message
    const { top } = this.$el.offset();
    const scrollable = this.$el.closest('.list-cards');

    return scrollable.scrollTop(top + this.$el.height());
  }

  getPlaceholder() {
    return l([
      'templates',
      'card_composer_inline',
      'enter-a-title-for-this-card-ellipsis',
    ]);
  }

  getCardTitle() {
    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    return guardedTrim($('.js-card-title', this.$el).val());
  }
}

export { CardComposerInlineView };
